import { Component, OnInit, Input, Output } from '@angular/core';
import { DestinationField } from '../../model/destination-field.enum';
import { EventEmitter } from '@angular/core';
import { DestinationTableItem } from '../../model/destination-table-item.enum';
import { DestinationAction } from '../../model/destination-action.enum';
import { GoogleLocationMapper } from '../../../../../services/googlemapper/google-location-mapper.service';
import { Pagination } from '../../../../../shared/models/pagination';
import { DestinationResponse } from '../../responses/destination.response';
import { ImportProgressResponse } from '../../responses/import-progress.response';

@Component({
    selector: 'app-destination-table',
    templateUrl: './destination-table.component.html',
    styleUrls: ['./destination-table.component.css'],
})
export class DestinationTableComponent implements OnInit {
    readonly DestinationField = DestinationField;
    readonly DestinationAction = DestinationAction;
    @Input() defaultFields: DestinationTableItem[] = [
        DestinationField.Name,
        DestinationField.Country,
        DestinationField.HousingsTotal,
        DestinationField.HousingsDone,
    ];
    @Input() additionalFields: DestinationField[] = [];
    @Input() destinations: DestinationResponse[];
    @Input() importProgress?: { [key: string]: ImportProgressResponse };
    @Input() pagination: Pagination;
    @Output() actionClicked = new EventEmitter<{
        action: DestinationAction;
        destination: DestinationResponse;
    }>();
    @Output() paginate = new EventEmitter<number>();
    shownFields: DestinationTableItem[];

    constructor() {}

    ngOnInit() {
        this.updateShownFields();
    }

    ngOnChanges() {
        this.updateShownFields();

        const mapper = new GoogleLocationMapper();
        for (const destination of this.destinations) {
            destination.boundary.mappedObj = mapper.map(
                destination.boundary.googleResponse
            );
        }
    }

    onActionClick(action: DestinationAction, destination: DestinationResponse) {
        this.actionClicked.emit({ action, destination });
    }

    sendPage(page: number) {
        this.paginate.emit(page);
    }

    private updateShownFields() {
        this.shownFields = [...this.defaultFields, ...this.additionalFields];
    }
}
